import { tv } from 'tailwind-variants'

export const typographyStyles = tv({
	base: 'text-palette_3 web:select-text',
	variants: {
		size: {
			small: 'text-sm',
			medium: 'text-base',
			large: 'text-lg',
			xl: 'text-xl',
			'2xl': 'text-2xl',
		},
		weight: {
			light: 'font-apercu-light',
			medium: 'font-apercu-primary',
			bold: 'font-apercu-bold',
		},
		underlined: {
			true: 'underline underline-offset-8',
		},
		spacing: {
			normal: 'tracking-normal',
			wide: 'tracking-[.15em]',
		},
	},
})
